module.exports = __webpack_public_path__ + "img/pic_shiny.3098de9c.png";